export type Theme = "dark" | "light";

export function isValidTheme(theme: string): theme is Theme {
  return theme === "dark" || theme === "light";
}
